// src/components/pages/transfer/TransfersPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Spin, message } from 'antd';
import TransfersList from './transfer_list';
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from 'react-router-dom';


const TransfersPage = () => {
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const fetchTransfers = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get('/transfers/transfer-list');
      setTransfers(response.data.transfers); // Laravel paginated response
    //   console.log(response.data.transfers);
    } catch (error) {
      message.error('Failed to load transfers');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectTransfer = (id) => {
    console.log('Selected transfer ID:', id);
    navigate(`/transfer-workflow/${id}`);
  };
  

  useEffect(() => {
    fetchTransfers();
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2>Transfers List</h2>
      {loading ? (
        <Spin />
      ) : (
        <TransfersList
          transfers={transfers}
          onSelectTransfer={handleSelectTransfer}
        />
      )}
    </div>
  );
};

export default TransfersPage;
